module.exports = __webpack_public_path__ + "img/tipsterfy.69b4af32.png";